import { render, staticRenderFns } from "./CellFormat.vue?vue&type=template&id=0a419470&scoped=true&%23cell()=data&"
import script from "./CellFormat.vue?vue&type=script&lang=ts&"
export * from "./CellFormat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a419470",
  null
  
)

export default component.exports